//import update from 'immutability-helper';
import uuidv4 from 'uuid/v4';

const emptyState = {
  open: false,
  dialog: null,
  params: {},
  tall: false,
  tallHeight: 0,
  dialogGuid: "",
  // Follow-up requested when the login dialog was opened (e.g. "new_contract").
  // Kept while sign-in replaces the dialog (email link, access code), cleared
  // whenever the overlay closes.
  pendingAction: ""
}

const OverlayReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "TALL_OVERLAY": {
      let { tall, height } = action.payload;

      return {...state,
        tall: tall,
        tallHeight: height
      };
    }
    case "OPEN_OVERLAY": {
      let { dialog, params } = action.payload;
      let dialogGuid = uuidv4().toLowerCase();

      let pendingAction = state.pendingAction || "";
      if (dialog === "login") {
        pendingAction = (params && typeof params === "object" && params.next) || "";
      }
      else if (dialog === "new_contract") {
        // Opening the chooser consumes the follow-up, so it runs only once.
        pendingAction = "";
      }

      return {...state,
        ...emptyState,
        open: true,
        dialog: dialog,
        params: params,
        tall: false,
        tallHeight: 0,
        dialogGuid,
        pendingAction
      };
    }
    case "CLOSE_OVERLAY": {
      let pendingAction = action.keepPendingAction ? (state.pendingAction || "") : "";
      return {...state, ...emptyState, pendingAction };
    }
    case "CLEAR_PENDING_OVERLAY_ACTION": {
      return {...state, pendingAction: "" };
    }
    default: {
      return state
    }
  }
}

export default OverlayReducer